import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

import { logout as authLogout } from '@lib/auth';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { tap } from 'rxjs/operators';

import { logoutUser } from './user.actions';

@Injectable()
export class UserEffects {
  private readonly actions$ = inject(Actions);
  private readonly router = inject(Router);
  private readonly store = inject(Store);

  logoutUser$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(logoutUser),
        tap(() => {
          localStorage.clear();
          this.store.dispatch(authLogout());
          this.router.navigate(['/login']);
        })
      ),
    { dispatch: false }
  );
}
